<template>
  <div class="c-select-butler">
    <Button :type="type" :disabled="disabled" @click="butlerModal = true">
      <span v-if="len">更新管家</span>
      <span v-else>选择管家</span>
    </Button>
    <dl>
      <dd v-for="manage in data" :key="manage.id" class="c-butler">
        <span>{{ manage.ruleName }}</span>
        <span v-show="!disabled" class="c-butler-del" @click="$emit('on-clear')">删除</span>
      </dd>
    </dl>
    <!-- 计划管家 -->
    <butler v-model="butlerModal" :selection="data" @on-cancel="butlerModal = false" @on-select="butlerSelect"></butler>
  </div>
</template>
<script>
import Butler from '@/components/butler/manager.vue'
export default {
  name: 'selectButler',
  components: { Butler },
  props: {
    data: {
      type: Array
    },
    disabled: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  computed: {
    len() {
      return Boolean(this.data.length)
    },
    type() {
      return this.len ? 'default' : 'primary'
    }
  },
  methods: {
    butlerSelect(meta) {
      meta && this.$emit('on-select', [meta])
      this.butlerModal = false
    }
  },
  data() {
    return {
      butlerModal: null
    }
  }
}
</script>
<style lang="scss" scoped>
.c-select-butler {
  position: relative;

  dl {
    margin-bottom: 0;
  }

  .c-butler {
    margin-top: 20px;

    span {
      display: inline-block;
      max-width: 380px;
      line-height: 1.2;

      &.c-butler-del {
        margin-left: 20px;
        color: #ff0000;
        cursor: pointer;
      }
    }
  }
}
</style>
